"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoHostingInfoProperty = getVideoHostingInfoProperty;
exports.findVideoInfoByProvider = findVideoInfoByProvider;
exports.getHubLVideoHubLTag = exports.getHubLParamsForVideoPlayer = exports.getIsConversionAssetValid = exports.getDoesConversionAssetHaveNecessaryProperties = exports.logBadConversionAssetData = exports.wrapTrackHubLVideoInteraction = exports.isHubLVideo = exports.getHubLVideoPlayerIdFromFile = exports.getHubLVideoParamObjectFromFile = void 0;

var _Constants = require("../Constants");

var _HubLVideoParams = require("../constants/HubLVideoParams");

var _getIn = _interopRequireDefault(require("./getIn"));

var _stringUtils = require("./stringUtils");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var CONVERSION_ASSET_NECESSARY_PROPERTIES = ['type', 'id', 'position'];

function getVideoHostingInfoProperty(file) {
  return (0, _getIn.default)(file, _Constants.PATH_TO_VIDEO_HOSTING_INFO);
}

function findVideoInfoByProvider(file, provider) {
  var hostingInfoList = getVideoHostingInfoProperty(file);

  if (hostingInfoList) {
    return hostingInfoList.find(function (e) {
      return e.provider === provider && e.status === 'ENABLED';
    }) || {};
  }

  return {};
}

var getHubLVideoParamObjectFromFile = function getHubLVideoParamObjectFromFile(file) {
  var width = file.width,
      height = file.height;

  if (getVideoHostingInfoProperty(file)) {
    return Object.assign({}, file.meta.video_data, {
      width: width,
      height: height,
      player_id: findVideoInfoByProvider(file, _Constants.VideoProviders.VIDYARD).id
    });
  }

  return {};
};

exports.getHubLVideoParamObjectFromFile = getHubLVideoParamObjectFromFile;

var getHubLVideoPlayerIdFromFile = function getHubLVideoPlayerIdFromFile(file) {
  return getHubLVideoParamObjectFromFile(file).player_id;
};

exports.getHubLVideoPlayerIdFromFile = getHubLVideoPlayerIdFromFile;

var isHubLVideo = function isHubLVideo(file) {
  return !!getHubLVideoPlayerIdFromFile(file);
};

exports.isHubLVideo = isHubLVideo;

var wrapTrackHubLVideoInteraction = function wrapTrackHubLVideoInteraction(trackInteraction) {
  return function (action) {
    return trackInteraction('Accept Video TOS', action);
  };
};

exports.wrapTrackHubLVideoInteraction = wrapTrackHubLVideoInteraction;

var logBadConversionAssetData = function logBadConversionAssetData(failureMessage) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  _devLogger.default.warn({
    message: "[Video HubL Tag] " + failureMessage + ". HubL tag will ignore it. " + error
  });
};

exports.logBadConversionAssetData = logBadConversionAssetData;

var getDoesConversionAssetHaveNecessaryProperties = function getDoesConversionAssetHaveNecessaryProperties(conversionAsset) {
  return CONVERSION_ASSET_NECESSARY_PROPERTIES.every(function (property) {
    return conversionAsset[property] !== null && conversionAsset[property] !== undefined;
  });
};

exports.getDoesConversionAssetHaveNecessaryProperties = getDoesConversionAssetHaveNecessaryProperties;

var getIsConversionAssetValid = function getIsConversionAssetValid(conversionAsset) {
  if (!(typeof conversionAsset === 'object' && conversionAsset !== null)) {
    logBadConversionAssetData('conversion_asset attribute needs to be a valid JSON object', "conversion_asset is " + (conversionAsset === null ? 'null' : 'not an object'));
    return false;
  } else if (!getDoesConversionAssetHaveNecessaryProperties(conversionAsset)) {
    logBadConversionAssetData("conversion_asset must have at least 3 properties: " + CONVERSION_ASSET_NECESSARY_PROPERTIES.join());
    return false;
  }

  return true;
};

exports.getIsConversionAssetValid = getIsConversionAssetValid;

var getHubLParamsForVideoPlayer = function getHubLParamsForVideoPlayer(params) {
  var hubLVideoPlayerParams = Object.assign({}, _HubLVideoParams.DefaultHubLVideoParams, {}, params);
  return Object.keys(hubLVideoPlayerParams).filter(function (key) {
    return _HubLVideoParams.SupportedHubLVideoParams.includes(key);
  }).filter(function (key) {
    return key !== 'conversion_asset' || getIsConversionAssetValid(hubLVideoPlayerParams[key]);
  }).map(function (key) {
    var val = hubLVideoPlayerParams[key];

    if (typeof val === 'boolean') {
      return key + "=" + (0, _stringUtils.capitalizeString)(val.toString());
    } else if (key === 'conversion_asset') {
      try {
        return "conversion_asset='" + JSON.stringify(val) + "'";
      } catch (error) {
        logBadConversionAssetData(error);
      }
    }

    return key + "='" + val + "'";
  }).join(', ');
};

exports.getHubLParamsForVideoPlayer = getHubLParamsForVideoPlayer;

var getHubLVideoHubLTag = function getHubLVideoHubLTag(params) {
  return "{% video_player \"embed_player\" " + getHubLParamsForVideoPlayer(params) + " %}";
};

exports.getHubLVideoHubLTag = getHubLVideoHubLTag;